import { FC, useId } from "react";

export const StarsIcon: FC<{
  variant?: "white" | "colored";
  size?: number;
}> = ({ variant = "white", size = 20 }) => {
  const uniqueId = useId();

  if (variant === "colored") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        style={{
          display: "inline-block",
          verticalAlign: "middle",
        }}
      >
        <g clipPath={`url(#clip-${uniqueId})`}>
          <path
            d="M5.4165 10.8333L6.07022 12.1408C6.29146 12.5832 6.40208 12.8045 6.54986 12.9962C6.681 13.1663 6.83351 13.3188 7.00363 13.45C7.19535 13.5978 7.41659 13.7084 7.85907 13.9296L9.1665 14.5833L7.85907 15.237C7.41659 15.4583 7.19535 15.5689 7.00363 15.7167C6.83351 15.8478 6.681 16.0003 6.54986 16.1705C6.40208 16.3622 6.29146 16.5834 6.07022 17.0259L5.4165 18.3333L4.76279 17.0259C4.54155 16.5834 4.43093 16.3622 4.28315 16.1705C4.15201 16.0003 3.9995 15.8478 3.82938 15.7167C3.63766 15.5689 3.41642 15.4583 2.97393 15.237L1.6665 14.5833L2.97393 13.9296C3.41642 13.7084 3.63766 13.5978 3.82938 13.45C3.9995 13.3188 4.15201 13.1663 4.28315 12.9962C4.43093 12.8045 4.54155 12.5832 4.76279 12.1408L5.4165 10.8333Z"
            stroke="#3C82FD"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.4165 10.8333L6.07022 12.1408C6.29146 12.5832 6.40208 12.8045 6.54986 12.9962C6.681 13.1663 6.83351 13.3188 7.00363 13.45C7.19535 13.5978 7.41659 13.7084 7.85907 13.9296L9.1665 14.5833L7.85907 15.237C7.41659 15.4583 7.19535 15.5689 7.00363 15.7167C6.83351 15.8478 6.681 16.0003 6.54986 16.1705C6.40208 16.3622 6.29146 16.5834 6.07022 17.0259L5.4165 18.3333L4.76279 17.0259C4.54155 16.5834 4.43093 16.3622 4.28315 16.1705C4.15201 16.0003 3.9995 15.8478 3.82938 15.7167C3.63766 15.5689 3.41642 15.4583 2.97393 15.237L1.6665 14.5833L2.97393 13.9296C3.41642 13.7084 3.63766 13.5978 3.82938 13.45C3.9995 13.3188 4.15201 13.1663 4.28315 12.9962C4.43093 12.8045 4.54155 12.5832 4.76279 12.1408L5.4165 10.8333Z"
            stroke={`url(#paint0-${uniqueId})`}
            strokeOpacity="0.56"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.4998 1.66667L13.482 4.22035C13.717 4.83138 13.8345 5.13689 14.0173 5.39387C14.1792 5.62163 14.3782 5.82063 14.606 5.98258C14.863 6.16531 15.1685 6.28281 15.7795 6.51782L18.3332 7.50001L15.7795 8.48219C15.1685 8.7172 14.863 8.8347 14.606 9.01743C14.3782 9.17938 14.1792 9.37838 14.0173 9.60614C13.8345 9.86312 13.717 10.1686 13.482 10.7797L12.4998 13.3333L11.5177 10.7797C11.2826 10.1686 11.1651 9.86312 10.9824 9.60614C10.8205 9.37838 10.6215 9.17938 10.3937 9.01743C10.1367 8.83471 9.83121 8.7172 9.22019 8.48219L6.6665 7.50001L9.22019 6.51782C9.83121 6.28281 10.1367 6.16531 10.3937 5.98258C10.6215 5.82063 10.8205 5.62163 10.9824 5.39387C11.1651 5.13689 11.2826 4.83138 11.5177 4.22035L12.4998 1.66667Z"
            stroke="white"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="#3C82FD"
            fillOpacity="0.2"
          />
          <path
            d="M12.4998 1.66667L13.482 4.22035C13.717 4.83138 13.8345 5.13689 14.0173 5.39387C14.1792 5.62163 14.3782 5.82063 14.606 5.98258C14.863 6.16531 15.1685 6.28281 15.7795 6.51782L18.3332 7.50001L15.7795 8.48219C15.1685 8.7172 14.863 8.8347 14.606 9.01743C14.3782 9.17938 14.1792 9.37838 14.0173 9.60614C13.8345 9.86312 13.717 10.1686 13.482 10.7797L12.4998 13.3333L11.5177 10.7797C11.2826 10.1686 11.1651 9.86312 10.9824 9.60614C10.8205 9.37838 10.6215 9.17938 10.3937 9.01743C10.1367 8.83471 9.83121 8.7172 9.22019 8.48219L6.6665 7.50001L9.22019 6.51782C9.83121 6.28281 10.1367 6.16531 10.3937 5.98258C10.6215 5.82063 10.8205 5.62163 10.9824 5.39387C11.1651 5.13689 11.2826 4.83138 11.5177 4.22035L12.4998 1.66667Z"
            stroke="#3C82FD"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.4998 1.66667L13.482 4.22035C13.717 4.83138 13.8345 5.13689 14.0173 5.39387C14.1792 5.62163 14.3782 5.82063 14.606 5.98258C14.863 6.16531 15.1685 6.28281 15.7795 6.51782L18.3332 7.50001L15.7795 8.48219C15.1685 8.7172 14.863 8.8347 14.606 9.01743C14.3782 9.17938 14.1792 9.37838 14.0173 9.60614C13.8345 9.86312 13.717 10.1686 13.482 10.7797L12.4998 13.3333L11.5177 10.7797C11.2826 10.1686 11.1651 9.86312 10.9824 9.60614C10.8205 9.37838 10.6215 9.17938 10.3937 9.01743C10.1367 8.83471 9.83121 8.7172 9.22019 8.48219L6.6665 7.50001L9.22019 6.51782C9.83121 6.28281 10.1367 6.16531 10.3937 5.98258C10.6215 5.82063 10.8205 5.62163 10.9824 5.39387C11.1651 5.13689 11.2826 4.83138 11.5177 4.22035L12.4998 1.66667Z"
            stroke={`url(#paint1-${uniqueId})`}
            strokeOpacity="0.56"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.4998 1.66667L13.482 4.22035C13.717 4.83138 13.8345 5.13689 14.0173 5.39387C14.1792 5.62163 14.3782 5.82063 14.606 5.98258C14.863 6.16531 15.1685 6.28281 15.7795 6.51782L18.3332 7.50001L15.7795 8.48219C15.1685 8.7172 14.863 8.8347 14.606 9.01743C14.3782 9.17938 14.1792 9.37838 14.0173 9.60614C13.8345 9.86312 13.717 10.1686 13.482 10.7797L12.4998 13.3333L11.5177 10.7797C11.2826 10.1686 11.1651 9.86312 10.9824 9.60614C10.8205 9.37838 10.6215 9.17938 10.3937 9.01743C10.1367 8.83471 9.83121 8.7172 9.22019 8.48219L6.6665 7.50001L9.22019 6.51782C9.83121 6.28281 10.1367 6.16531 10.3937 5.98258C10.6215 5.82063 10.8205 5.62163 10.9824 5.39387C11.1651 5.13689 11.2826 4.83138 11.5177 4.22035L12.4998 1.66667Z"
            stroke={`url(#paint2-${uniqueId})`}
            strokeOpacity="0.56"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id={`paint0-${uniqueId}`}
            x1="9.1665"
            y1="14.5901"
            x2="1.6665"
            y2="14.5894"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F68EB4" />
            <stop offset="0.500638" stopColor="#CE5CFB" />
            <stop offset="1" stopColor="#2B78FF" />
          </linearGradient>
          <linearGradient
            id={`paint1-${uniqueId}`}
            x1="18.3332"
            y1="7.51057"
            x2="6.6665"
            y2="7.5095"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#8ED1F6" />
            <stop offset="0.500638" stopColor="#CE5CFB" />
            <stop offset="1" stopColor="#2B78FF" />
          </linearGradient>
          <linearGradient
            id={`paint2-${uniqueId}`}
            x1="18.3332"
            y1="7.51057"
            x2="6.6665"
            y2="7.5095"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F68EB4" />
            <stop offset="0.500638" stopColor="#CE5CFB" />
            <stop offset="1" stopColor="#2B78FF" />
          </linearGradient>
          <clipPath id={`clip-${uniqueId}`}>
            <rect width={size} height={size} fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: "inline-block",
        verticalAlign: "middle",
      }}
    >
      <g id="stars-01" clipPath={`url(#clip-white-${uniqueId})`}>
        <path
          d="M5.4165 10.8333L6.07022 12.1408C6.29146 12.5832 6.40208 12.8045 6.54986 12.9962C6.681 13.1663 6.83351 13.3188 7.00363 13.45C7.19535 13.5978 7.41659 13.7084 7.85907 13.9296L9.1665 14.5833L7.85907 15.237C7.41659 15.4583 7.19535 15.5689 7.00363 15.7167C6.83351 15.8478 6.681 16.0003 6.54986 16.1705C6.40208 16.3622 6.29146 16.5834 6.07022 17.0259L5.4165 18.3333L4.76279 17.0259C4.54155 16.5834 4.43093 16.3622 4.28315 16.1705C4.15201 16.0003 3.9995 15.8478 3.82938 15.7167C3.63766 15.5689 3.41642 15.4583 2.97393 15.237L1.6665 14.5833L2.97393 13.9296C3.41642 13.7084 3.63766 13.5978 3.82938 13.45C3.9995 13.3188 4.15201 13.1663 4.28315 12.9962C4.43093 12.8045 4.54155 12.5832 4.76279 12.1408L5.4165 10.8333Z"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.4165 10.8333L6.07022 12.1408C6.29146 12.5832 6.40208 12.8045 6.54986 12.9962C6.681 13.1663 6.83351 13.3188 7.00363 13.45C7.19535 13.5978 7.41659 13.7084 7.85907 13.9296L9.1665 14.5833L7.85907 15.237C7.41659 15.4583 7.19535 15.5689 7.00363 15.7167C6.83351 15.8478 6.681 16.0003 6.54986 16.1705C6.40208 16.3622 6.29146 16.5834 6.07022 17.0259L5.4165 18.3333L4.76279 17.0259C4.54155 16.5834 4.43093 16.3622 4.28315 16.1705C4.15201 16.0003 3.9995 15.8478 3.82938 15.7167C3.63766 15.5689 3.41642 15.4583 2.97393 15.237L1.6665 14.5833L2.97393 13.9296C3.41642 13.7084 3.63766 13.5978 3.82938 13.45C3.9995 13.3188 4.15201 13.1663 4.28315 12.9962C4.43093 12.8045 4.54155 12.5832 4.76279 12.1408L5.4165 10.8333Z"
          stroke="white"
          strokeOpacity="0.56"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4998 1.66667L13.482 4.22035C13.717 4.83138 13.8345 5.13689 14.0173 5.39387C14.1792 5.62163 14.3782 5.82063 14.606 5.98258C14.863 6.16531 15.1685 6.28281 15.7795 6.51782L18.3332 7.50001L15.7795 8.48219C15.1685 8.7172 14.863 8.8347 14.606 9.01743C14.3782 9.17938 14.1792 9.37838 14.0173 9.60614C13.8345 9.86312 13.717 10.1686 13.482 10.7797L12.4998 13.3333L11.5177 10.7797C11.2826 10.1686 11.1651 9.86312 10.9824 9.60614C10.8205 9.37838 10.6215 9.17938 10.3937 9.01743C10.1367 8.83471 9.83121 8.7172 9.22019 8.48219L6.6665 7.50001L9.22019 6.51782C9.83121 6.28281 10.1367 6.16531 10.3937 5.98258C10.6215 5.82063 10.8205 5.62163 10.9824 5.39387C11.1651 5.13689 11.2826 4.83138 11.5177 4.22035L12.4998 1.66667Z"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="#3C82FD"
          fillOpacity="0.2"
        />
        <path
          d="M12.4998 1.66667L13.482 4.22035C13.717 4.83138 13.8345 5.13689 14.0173 5.39387C14.1792 5.62163 14.3782 5.82063 14.606 5.98258C14.863 6.16531 15.1685 6.28281 15.7795 6.51782L18.3332 7.50001L15.7795 8.48219C15.1685 8.7172 14.863 8.8347 14.606 9.01743C14.3782 9.17938 14.1792 9.37838 14.0173 9.60614C13.8345 9.86312 13.717 10.1686 13.482 10.7797L12.4998 13.3333L11.5177 10.7797C11.2826 10.1686 11.1651 9.86312 10.9824 9.60614C10.8205 9.37838 10.6215 9.17938 10.3937 9.01743C10.1367 8.83471 9.83121 8.7172 9.22019 8.48219L6.6665 7.50001L9.22019 6.51782C9.83121 6.28281 10.1367 6.16531 10.3937 5.98258C10.6215 5.82063 10.8205 5.62163 10.9824 5.39387C11.1651 5.13689 11.2826 4.83138 11.5177 4.22035L12.4998 1.66667Z"
          stroke="white"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4998 1.66667L13.482 4.22035C13.717 4.83138 13.8345 5.13689 14.0173 5.39387C14.1792 5.62163 14.3782 5.82063 14.606 5.98258C14.863 6.16531 15.1685 6.28281 15.7795 6.51782L18.3332 7.50001L15.7795 8.48219C15.1685 8.7172 14.863 8.8347 14.606 9.01743C14.3782 9.17938 14.1792 9.37838 14.0173 9.60614C13.8345 9.86312 13.717 10.1686 13.482 10.7797L12.4998 13.3333L11.5177 10.7797C11.2826 10.1686 11.1651 9.86312 10.9824 9.60614C10.8205 9.37838 10.6215 9.17938 10.3937 9.01743C10.1367 8.83471 9.83121 8.7172 9.22019 8.48219L6.6665 7.50001L9.22019 6.51782C9.83121 6.28281 10.1367 6.16531 10.3937 5.98258C10.6215 5.82063 10.8205 5.62163 10.9824 5.39387C11.1651 5.13689 11.2826 4.83138 11.5177 4.22035L12.4998 1.66667Z"
          stroke="white"
          strokeOpacity="0.56"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4998 1.66667L13.482 4.22035C13.717 4.83138 13.8345 5.13689 14.0173 5.39387C14.1792 5.62163 14.3782 5.82063 14.606 5.98258C14.863 6.16531 15.1685 6.28281 15.7795 6.51782L18.3332 7.50001L15.7795 8.48219C15.1685 8.7172 14.863 8.8347 14.606 9.01743C14.3782 9.17938 14.1792 9.37838 14.0173 9.60614C13.8345 9.86312 13.717 10.1686 13.482 10.7797L12.4998 13.3333L11.5177 10.7797C11.2826 10.1686 11.1651 9.86312 10.9824 9.60614C10.8205 9.37838 10.6215 9.17938 10.3937 9.01743C10.1367 8.83471 9.83121 8.7172 9.22019 8.48219L6.6665 7.50001L9.22019 6.51782C9.83121 6.28281 10.1367 6.16531 10.3937 5.98258C10.6215 5.82063 10.8205 5.62163 10.9824 5.39387C11.1651 5.13689 11.2826 4.83138 11.5177 4.22035L12.4998 1.66667Z"
          stroke="white"
          strokeOpacity="0.56"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={`clip-white-${uniqueId}`}>
          <rect width={size} height={size} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
